const prependProtocol = (url?: string | null): string | null | undefined => {
  if (url && !/^https?:\/\//i.test(url)) {
    url = 'http://' + url;
  }
  return url;
};

export default prependProtocol;
